<div id="menu" style="text-align: center !important;position: relative;">
  <button id="x" style="position: absolute;top: 0p;right: 0px;" (click)="closeSheet()">X</button>
  <button class="Hb" mat-raised-button style="background-color: yellow;color: black;"><a
      href="https://fananpaymentfile.firebaseapp.com/index">Buy page </a><i class="fas fa-sign-out-alt"></i></button>
  <br>
  <button class="Hb" mat-raised-button style="background-color: yellow;color: black;"><a
      href="https://www.fananteampro.com/">Fanan home page </a><i class="fas fa-sign-out-alt"></i></button>
  <br>
  <button class="Hb" mat-raised-button color="warn" (click)="logout()">Log out <i
      class="fas fa-sign-out-alt"></i></button>

</div>
